export default "__VITE_ASSET__DAp68xIX__"